import {React, useState, useEffect} from 'react';
import axios from 'axios';
import '../../App.css'
import {Grid, TextField, Box, Button,Paper,Stack,FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, InputLabel, Select, MenuItem, Checkbox, FormHelperText,Typography} from '@mui/material';
import {Preview, PermDataSetting} from '@mui/icons-material';
import * as monthList from '../../services/monthList';
import Popup from '../Popup';
import DataTable from '../DataTable';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';

// Custom component for required field label
const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red' , marginLeft: '3px' }}>*</span>
  </span>
);

const monthOptions = monthList.getMonthList();

const initialFValues={
  id: 0,
  taxFrom: '',
  taxTo: '',
  gender: '',
  taxAmount: '',
  isException: '',
  exceptionMonth: '',
  exceptionAmount: '0.0',
  effectiveDate: new Date(),
}

function PTSlabsConfiguration(props){

  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();

  useEffect(() => {
      if (notify.isOpen && notify.type === 'success') {
        // Close modal immediately for updates, with delay for adds
        const delay = props.fetch_id !== 9999 ? 0 : 100;
        
        const timer = setTimeout(() => {
          // Call the parent's function to close the modal
          if (props.onCloseModal) {
            props.onCloseModal();
          }
        }, delay);
        
        return () => clearTimeout(timer);
      }
    }, [notify, props.onCloseModal, props.fetch_id]);

  const validate = () => {
    let temp = {}
    temp.taxFrom = values.taxFrom !== '' ? "" : "This field is required."
    temp.taxTo = values.taxTo ? "" : "This field is required."
    temp.taxAmount = values.taxAmount ? "" : "This field is required."

    // Only validate exception fields if exception is checked
    if (values.isException) {
      temp.exceptionMonth = values.exceptionMonth ? "" : "Exception month is required when exception is enabled."
      temp.exceptionAmount = values.exceptionAmount ? "" : "Exception amount is required when exception is enabled."
    }

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }

  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [taxes, setTaxes] = useState({});
  const dispatch = useDispatch();

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  }

  useEffect(() => {
    async function getPTSlab(){
      if(props.fetch_id != 9999) {
        try {
          const taxes =  await axios.get(`${process.env.REACT_APP_API_BASE_URL}/configure/pt-slab-configure/get-pt-slab/` + props.fetch_id);
          setTaxes(taxes.data[0]);

          // Check if the data contains exception fields
          const hasExceptionData = taxes.data[0].ExceptionAmount !== null && 
                                  taxes.data[0].ExceptionAmount !== undefined && 
                                  taxes.data[0].ExceptionMonth !== null && 
                                  taxes.data[0].ExceptionMonth !== undefined;

          const editFValues = {
            taxFrom: taxes.data[0].TaxFrom,
            taxTo: taxes.data[0].TaxTo,
            gender: taxes.data[0].Gender,
            taxAmount: taxes.data[0].TaxAmount,
            exceptionMonth: taxes.data[0].ExceptionMonth,
            exceptionAmount: taxes.data[0].ExceptionAmount,
            isException: hasExceptionData || taxes.data[0].IsException || false,
          }

          setValues(editFValues);


        } catch (e) {
          if(e.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            },1000);
          }
        }
      } else {
        setValues(initialFValues)
      }
      }
    getPTSlab();
  },[]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if(validate()) {
      let URL = '';
      if(props.fetch_id === 9999){
        URL = `${process.env.REACT_APP_API_BASE_URL}/configure/pt-slabs-configure/add`;
      }else {
        URL = `${process.env.REACT_APP_API_BASE_URL}/configure/pt-slabs-configure/edit/` + props.fetch_id;
      }

      // Format payload according to requirements
      let payload;
      if (values.isException) {
        // With exception
        payload = {
          taxFrom: parseFloat(values.taxFrom),
          taxTo: parseFloat(values.taxTo),
          taxAmount: parseFloat(values.taxAmount),
          isException: true,
          exceptionMonth: values.exceptionMonth,
          exceptionAmount: parseFloat(values.exceptionAmount || 0),
          gender: values.gender
        };
      } else {
        // Without exception - don't include exception fields at all
        payload = {
          taxFrom: parseFloat(values.taxFrom),
          taxTo: parseFloat(values.taxTo),
          taxAmount: parseFloat(values.taxAmount),
          isException: false,
          gender: values.gender
        };
      }

      // Debug: Log the payload being sent
      console.log('PT Slabs Payload being sent:', payload);
      
      axios.post(URL, payload)
      .then(function (response) {
        if(response.status === 200) {
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: 'success'
          });
          dispatch(updateTableActions.startUpdatePTslabsConfig());
          
        }
      })
      .catch(function (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error',
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        } else if (e.response.status === 422) {
          setNotify({
            isOpen: true,
            message: e.response.data.error_message.sqlMessage,
            type: 'error',
          });
        }
      });
    }
  }

  return(
    <Box sx={{display: "flex", justifyContent: "center", margin: "-10px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={5} sx={{width: "500px", marginTop: "-20px"}}>
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>PT Slabs Configuration</Typography> </Grid>
          <Grid item> <PermDataSetting style={{marginLeft: "-50px"}} sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Stack spacing={2} sx={{margin: "30px"}}>

            <Stack className="form-input-row" direction="row" spacing={2}>
              <TextField
                variant="outlined"
                name="taxFrom"
                label={<RequiredLabel label="From (&#8377;)" />}
                size="small"
                value={values.taxFrom}
                onChange={handleInputChange}
                {...(errors.taxFrom && {error:true, helperText: errors.taxFrom} )}
              />
              <TextField
                variant="outlined"
                name="taxTo"
                label={<RequiredLabel label="To (&#8377;)" />}
                size="small"
                value={values.taxTo}
                onChange={handleInputChange}
                {...(errors.taxTo && {error:true, helperText: errors.taxTo} )}
              />
            </Stack>

            <FormControl>
              <FormLabel>Gender</FormLabel>
              <RadioGroup
                row={true}
                name="gender"
                value={values.gender}
                onChange={handleInputChange}
              >
                <FormControlLabel value="F" control={<Radio />} label="Female" />
                <FormControlLabel value="M" control={<Radio />} label="Male" />
                <FormControlLabel value="O" control={<Radio />} label="Other" />
              </RadioGroup>
            </FormControl>

            <TextField
              variant="outlined"
              id="outlined-basic"
              label={<RequiredLabel label="Amount (&#8377;)" />}
              name="taxAmount"
              size="small"
              value={values.taxAmount}
              onChange={handleInputChange}
              {...(errors.taxAmount && {error:true, helperText: errors.taxAmount} )}
            />

            {/* <Stack className="center-aligned">
              <TextField
                variant="outlined"
                className="date-picker"
                type="date"
                label="Effective Date"
                name="effectiveDate"
                defaultValue="2017-05-24"
                value={values.effectiveDate}
                onChange={handleInputChange}
              />
            </Stack> */}

            <Stack className="form-input-row" direction="row" spacing={2}>
                <FormControl>
                  <FormControlLabel
                    control={<Checkbox
                            name="isException"
                            color="primary"
                            checked={values.isException}
                            onChange={ e => handleInputChange(convertToDefEventPara("isException", e.target.checked))}
                            />}
                            label="Exception?"
                            />
                </FormControl>
              </Stack>


          { values.isException ?
          <Stack className="form-input-row" direction="row" spacing={2}>
            <Stack sx={{width: "200px"}}>
            <FormControl
              variant="outlined"
              {...(errors.exceptionMonth && {error:true} )}>
                <InputLabel>Select Exception Month</InputLabel>
                <Select
                  label="Select Exception Month"
                  name="exceptionMonth"
                  size="small"
                  value={values.exceptionMonth}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                    {
                      monthOptions.map(
                        item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                      )
                    }

                </Select>
                { errors.exceptionMonth && <FormHelperText>{errors.exceptionMonth}</FormHelperText>}
            </FormControl>
            </Stack>

            <TextField
              variant="outlined"
              id="outlined-basic"
              label=" Exception Amount (&#8377;)"
              name="exceptionAmount"
              size="small"
              value={values.exceptionAmount}
              onChange={handleInputChange}
              {...(errors.exceptionAmount && {error:true, helperText: errors.exceptionAmount} )}
            />
            </Stack>
            : ""}

            <Grid container className="form-btn-container" justifyContent="center">
                <Grid item>
                  <Button variant="contained" color="primary" onClick={handleSubmit} type="submit">Save</Button>
                </Grid>
            </Grid>

            </Stack>
        </form>


        <Button className="form-btn" variant="outlined" color="error" onClick={() => setOpenPopup(true)} startIcon={<Preview sx={{width: "30px", height: "30px"}}/>} >Show</Button>

        <Popup
        title="Employee Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <DataTable/>
        </Popup>


      </Paper>
      <Notification
            notify={notify}
            setNotify={setNotify} />
    </Box>
  )
}

export default PTSlabsConfiguration;
